import React, { Fragment } from "react";

function RefundContactNotice({ ofWhat, isNew }) {
  return (
    <Fragment>
      {" "}
      Depending on the fee refund policy shown on your original registration
      receipt, you may in some circumstances be entitled to a refund of {ofWhat}
      . {isNew ? "Please" : "If you have not already done so, please"} contact
      the staff member responsible for the event to arrange this, if applicable.
    </Fragment>
  );
}
export default RefundContactNotice;
